export const STANDARD_PLATFORM_POSITIONING =
  'The Standard helps disciplined men and women elevate their body, faith, relationships, leadership, and purpose.';

export const STANDARD_PLATFORM_AUDIENCE =
  'Built for high performers, individuals ready to elevate their lives, and people tired of being tired.';

export const STANDARD_PROGRAM_AUDIENCE_GUIDANCE =
  'The platform serves men and women. Individual programs may be built specifically for men, women, husbands, wives, fathers, mothers, or defined cohorts.';
